import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './components/modal/modal.component';
import { PagetitleComponent } from './components/pagetitle/pagetitle.component';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { HasDeniedDirective } from './directives/has-denied.directive';
import { HasDeniedItemsDirective } from './directives/has-denied-items-directive';



@NgModule({
  declarations: [
    ModalComponent,
    PagetitleComponent,
    HasPermissionDirective,
    HasDeniedDirective,
    HasDeniedItemsDirective,

  ],
  imports: [
    CommonModule
  ],
  exports: [
    ModalComponent,
    PagetitleComponent,
    HasPermissionDirective,
    HasDeniedDirective,
    HasDeniedItemsDirective
  ]
})
export class SharedModule { }
